import React from 'react';

const Radio = (props) => {
    return (
        <label style = {{ position: 'relative', opacity: props.disabled ? 0.3 : 1 }}>
            <input
                type = 'radio'
                value = { props.value }
                checked = { props.checked }
                onChange = { props.handleChange }
                style = {{ opacity: 0, margin: '0 10px' }}
                name = { props.name }
                tabIndex = { props.tab }
                disabled = { props.disabled }
            />
            { props.showValue }
            <span style = {{
                position: 'absolute',
                left: '7px',
                top: '0',
                width: '15px',
                height: '15px',
                border: '1px solid ' + window.color.searchBoxBgColor,
                borderRadius: '50%'
            }}></span>
            <span style = {{
                position: 'absolute',
                left: '11px',
                top: '4px',
                width: '7px',
                height: '7px',
                background: props.checked ? window.color.searchBoxBgColor : '#fff',
                borderRadius: '50%',
                zIndex: 2
            }}></span>
        </label>
    );
}

export default Radio;